import { FaCheckCircle } from 'react-icons/fa';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: auto;
  gap: 8px;
`;

const Item = styled.div<{ $checked?: boolean }>`
  aspect-ratio: 1;
  position: relative;
  cursor: pointer;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  object-fit: contain;
`;

interface ImageSelectInputProps {
  value?: string[];
  options?: { label: string; value: string; image: string }[];
  onChange?: (value: string[]) => void;
}

export const ImageSelectInput = ({
  value,
  options,
  onChange,
}: ImageSelectInputProps) => {
  return (
    <Container>
      {options?.map((option) => {
        const checked = value?.includes(option.value);

        return (
          <Item
            key={option.value}
            $checked={checked}
            onClick={() => {
              if (checked) {
                onChange?.((value ?? []).filter((val) => val !== option.value));
              } else {
                onChange?.([...(value ?? []), option.value]);
              }
            }}
          >
            {checked && (
              <Overlay>
                <FaCheckCircle color="black" width={42} height={42} />
              </Overlay>
            )}
            <Image src={option.image} alt={option.label} />
          </Item>
        );
      })}
    </Container>
  );
};
